import Utils from 'core-helpers/utils.js';
import ScriptLoader from 'core-helpers/script-loader.js';
import ThirdPartyService from 'core-services/third-party-service.js';
import PubSub from 'pubsub-js/src/pubsub.js';

/**
 * Trustpilot
 */
(function(root, doc, undefined) {

    'use strict';

    const isVendorDisabled = function() {
        return ThirdPartyService.isVendorDisabled();
    };

    const onTrustpilotLoaded = function() {
        PubSub.publish('TRUSTPILOT_WIDGET_LOADED');
    };

    const init = () => {

        if (isVendorDisabled()) {
            return false;
        }

        const trustpilot = Utils.getById('trustpilot');
        if (!trustpilot) {
            return false;
        }

        const trustpilotTemplate = trustpilot.getAttribute('data-template-id');

        // Inject it! (delayed after load event)
        ScriptLoader.add(trustpilotTemplate, 'trustpilot', onTrustpilotLoaded);

    };

    init();

})(window, document);
